import { Component, Inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { StepperModule } from 'primeng/stepper';
import { ButtonComponent } from '../../../@core/components/ui/button/button.component';
import { ToastService } from '../../../@core/services/toast.service';
import { FileDropComponent } from '../../../@shared/components/file-drop/file-drop.component';
import { FileDropTypes } from '../../../@shared/components/file-drop/file-drop.types';
import { ContractService } from '../../services/contracts.service';

@Component({
  selector: 'app-create-contract',
  standalone: true,
  imports: [StepperModule, FileDropComponent, ReactiveFormsModule, MatDialogModule, ButtonComponent],
  templateUrl: './create-contract.component.html',
  styleUrl: './create-contract.component.scss'
})
export class CreateContractComponent {

  fileData: File = new File([''], 'filename');
  files: File[] = [];
  myForm!: FormGroup;
  message: string = '';
  isFileAdded: boolean = false;
  htmlContent: string = '';
  public allowedFileTypes: string[] = [FileDropTypes.PDF, FileDropTypes.DOCX, FileDropTypes.DOC];
  multiple: boolean = false;
  loading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { contractId: string, allowMultiple?: boolean, returnUploadedDoc?: boolean },
    private contractService: ContractService,
    public dialogRef: MatDialogRef<CreateContractComponent>,
    private toastService: ToastService
  ) {
    this.multiple = data.allowMultiple ?? false;
  }


  onFileUploaded(file: File | File[]) {
    if (Array.isArray(file) && ((this.data?.allowMultiple && file.length > 0) || (!this.data?.allowMultiple && file.length == 1))) {
      const fileExtension = file[0].name.split('.').pop()?.toLocaleLowerCase();
      if (this.allowedFileTypes.includes('.' + fileExtension)) {
        if (this.data?.allowMultiple) {
          this.files = file;
        } else {
          this.fileData = file[0];
        }
        this.isFileAdded = true;
      } else {
        this.message = 'Please upload Only .docx, .doc and .pdf File';
        alert(this.message);
      }
    } else if (Array.isArray(file) && file.length > 1 && !this.data?.allowMultiple) {
      this.toastService.error('Please upload single file')
    }
  }

  onFileRemove(file: File) {
    if (this.data?.allowMultiple) {
      this.files = this.files.filter(f => f !== file);
      this.isFileAdded = this.files.length > 0;
    } else {
      this.fileData = new File([''], 'filename');
      this.isFileAdded = false;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  createContract() {
    if (this.data.returnUploadedDoc) {
      this.dialogRef.close(this.data?.allowMultiple ? this.files : this.fileData);
      return;
    }
    this.loading = true
    let form: FormData = new FormData();
    const fileName = this.fileData.name.substring(0, this.fileData.name.lastIndexOf('.')) || this.fileData.name;
    form.append('name', fileName)
    form.append('id', this.data.contractId)
    form.append('file', this.fileData)

    this.contractService.uploadContract(form).subscribe({
      next: (res) => {
        this.loading = false
        if (res.success && res.data) {
          this.dialogRef.close(res.data);
        }
      },
      error: _ => this.loading = false
    })
  }


}
